import { UserContextMenu } from '@uag/react-core';

type HeaderProps = {
    title: string;
    onClose?: () => void;
};

export const Header = ({ title, onClose }: HeaderProps) => {
    return (
        <div className="headerbar">
            <div className="headerbar-content">
                <div className="headerbar-logo" />
                <span className="headerbar-title">{title}</span>
                <div className="headerbar-section">
                    {onClose ?
                        <div className="headerbar-action" onClick={() => onClose()}>
                            <div className="headerbar-action-icon">close</div>
                        </div> :
                        <UserContextMenu isMobileSidebarVisible={false} />
                    }
                </div>
            </div>
        </div>
    );
};
